import React, { useState } from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useDispatch, useSelector } from 'react-redux';
import ColorComponent from '../../components/ColorComponent';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import { tableTheme } from '../../helpers/tableTheme';
import { useHistory } from 'react-router-dom';

const columns = [
  {
    name: 'Customer Id',
    label: 'Customer Id',
    options: {
      filter: false,
      sort: true,
      display: 'excluded',
    },
  },
  {
    name: 'Name',
    label: 'Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Status',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
];

function formatCollectorAssignedCustomerData(data) {
  if (data.length === 0) return [];
  const formattedData = data?.map((item) => [
    item?.customerId ?? '',
    item?.accountName ?? '',
    item?.isActive ?? '',
  ]);
  return formattedData ?? [];
}

function CollectorAssignedCustomer() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  //change this to a new api call and refactor this
  const assignedData = useSelector(
    (state) => state.collector?.individualCollector?.assignedCustomerList ?? []
  );

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/customers/profile/${rowData[0]}`);
  };

  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    responsive: 'standard',
    print: false,
    download: false,
    elevation: 0,
    onRowClick: onRowsSelect,
  };

  return (
    <div>
      <MuiThemeProvider theme={tableTheme}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <MUIDataTable
            title={'Assigned Customers'}
            data={formatCollectorAssignedCustomerData(assignedData)}
            columns={columns}
            options={options}
          />
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default CollectorAssignedCustomer;
